export default {
  disclaimer: '免责声明',
  privacy: '私隐政策',
  usage: '使用守则',
  dis:[ 
    "{0}（HKLII）是{1}的研究项目，本中心是由香港大学{2}和香港大学{3}共同建立的，并得到 {4}（AustLII）的协助，而 AustLII 是由{5}和{6}联合营运（“主办大学”）。",
    "“HKLII 资料提供者” 包括但不限于香港特别行政区的司法机构，香港特别行政区律政司、香港国际仲裁中心和香港大学。",
    "HKLII 是提供免费服务，而HKLII提供的所有资讯均可于其他来源取得。",
    "HKLII、主办大学或 HKLII 资料提供者均不建议使用者依赖 HKLII 所提供之资讯。HKLII 对 HKLII 所提供之资讯、用途以及使用上述资讯而引致的法律后果概不负责。",
    "HKLII、主办大学或 HKLII 资料提供者均不保证、承诺或担保HKLII所提供资料为准确、完整或最新。如用户将有关资料用作重要用途，应先从其他来源核实有关资料。如用户需法律参考材料的正式版本，应参考有关官方刊物。",
    "HKLII 上的超文本链接均由 HKLII 而非由资料提供者所建立。HKLII 上的超文本链接是通过程序以自动方式建立，故并非所有链接均全面及准确。HKLII、主办大学或 HKLII 资料提供者就超文本链接的准确性，全面性或其他任何方面均不作任何保证、承诺或担保。一般而言，超文本链接仅为各资料提供互连。"
  ],
  austlii: 'Australasian Legal Information Institute',
  unsw: '新南威尔士大学',
  uts: '悉尼科技大学',
  pp: [
    "HKLII 的私隐政策是根据保护资料私隐的国际标准制定。",
    "HKLII 将收集访问 HKLII 页面用家的网络身份。 有关资料将用于网络分析、使用情况分析以及对使用模式的研究，从而改善 HKLII 的服务。只有HKLII的管理及研究人员才能够取得及使用有关资料，该些人员亦必须遵守此私隐政策。",
    "HKLII 不会在未经许可的情兄下透露或发布任何足以辨识个别机器或可能辨识地址子组别的资料，惟 HKLII 会发布有关用家使用模式的汇总资料。",
    "HKLII 保留收集更广泛资讯的权利，包括(i)任何尝试访问 HKLII 而引致的安全问题（并在必要时向相关部门披露）；及(ii)不定期进行网络分析。",
    "HKLII 的某些资料库包含个人资料，包括法院和审裁处的判决。HKLII 是有关公共机构的同意下发布这些资料库，而有关公共机构有责任在遵守其运作的法律要求的情况下，在资料传播方面平衡个人私隐和公共利益。如有需要对个人资料进行匿名处理，有关工作则由则由相关的公共机构负责。",
    "HKLII 并不同意其他网站将这些资料库的内容编入索引。HKLII试图通过将这些资料库置于符合自愿机器人排除标准的“网络爬虫”、“网络机械人”及“网络蜘蛛”的允许范围之外来防止此类索引的发生。在某些情况下，HKLII 会为其他法律网站对 HKLII 资料库进行索引作例外处理。",
    "HKLII 还会监察是否有任何网络机械人在违反此政策的情况下，尝试对这些资料库建立索引，一经发现将采取措施禁止其访问 HKLII 网站。",
    "HKLII 保留禁止任何明显违反此等法律要求的用户或网站访问其资料库的权利。",
    "如你对此政策有任何意见或建议，欢迎向我们提出{0}。",
  ],
  pp_a: "A. 有关 HKLII 的使用资讯",
  pp_b: "B. HKLII 资料库中包含的个人资料",
  pp_feedback: "意见",
  up_title: "有关 HKLII 文件的使用守则",
  up_1: "1.  一般原则",
  up_2: "2. 最终用户",
  up_3: "3. HKLII 内容的版权",
  up_4: "4. 其他商业及非商业系统使用 HKLII 资料",
  up_5: "5. 法院和其他资料提供者提供的原始文件",
  up:[
    "HKLII 是非牟利的发布者，它为个人最终用户提供免费资讯，让公众能阅读、打印和复制有关资料作个人用途及其他版权法下允许的用途。",
    "为提供这项服务，HKLII 与文件的来源和文件的版权持有人达成协议，或在版权持有人的许可下，建立了一套一手和二手法律资讯（包括案例、条例、条约和法律改革文件）的集合。",
    "HKLII 不是资料存储库，因为它不为其他发布者提供从 HKLII 获取文件进行重新发布的服务。其他发布者需要从其原始来源或通过其他适当的授权途径获得这些文件。",
    "对于 HKLII 发布的所有文件，HKLII 不允许任何人重新发布由 HKLII 添加到文档中的增值内容（包括超文本标记和替代引文）。此限制并不包括 HKLII 使用引述案例通用编号 (Neutral Citations)（不论是否由 HKLII 增设）。",
    "HKLII 对复制和使用案例文件加设了限制。HKLII 阻截所有网络蜘蛛和其他自动化代理程序通过机器人排除标准来访问案例文件。HKLII 的政策与国际上所有类似组织相同。这项政策的原因包括：",
    "HKLII 系统的个人最终用户可根据版权法自由访问，复制和打印作个人用途的资料;",
    "案例的使用受上述(1)(e)条约束。",
    "HKLII 并不拥有其发布的原始文件的版权，故不能授权其他人复制这些原始文件。",
    "HKLII 持有其添加到原始文件中的所有增值内容（包括超文本标记和替代引文）之版权。HKLII 一般会应使用者的要求允许复制有关内容作教学、培训或相关用途。",
    "HKLII 不会将其由其他来源取得之原始文件存储或提供予其他发布者重新发布。此政策适用于文档的主动搜集，以及通过网络蜘蛛或其他自动收集程序进行的被动搜集。如果上述网络蜘蛛或其他程序自动收集行为明显可见，HKLII 系统将作出拦截。",
    "在一些情况下，HKLII 会与其他发布者协商协议，将 HKLII 页面加为其服务的一部分，包括协助他们链接正确的 HKLII 页面。",
    "HKLII 支持法院和其他公共法律资讯提供者向大众提供法律资讯（如案例、法律条文等），而他们有责任(i)持续提供资料予各发布者及(ii)保留已提供的资料的副本。",
    "HKLII 将应有关要求就(a)(ii)项所述协助法院或其他公共法律资讯提供者。",
    "各级法院或其他公共法律资讯提供者都就有关私隐（包括通过第三方搜索引擎访问）、 “撤销”或替换判决，以及第三方重新发布资料（包括版权政策）等事宜制定各自的政策。",
    "HKLII 遵守各级法院或其他公共法律资讯提供者的政策，并支持制定有关此类政策的标准。",
    "HKLII 可酌情修改此政策。"
  ],
  up_1e:[
    "HKLII 必须遵守法院和当事人的移除、匿名和其他修改要求；",
    "HKLII 必须遵守资料提供者订下的许可条件；和",
    "HKLII 必须平衡个人私隐与开放访问之间的需求，特别是使用搜索引擎时。",
  ],
  date: "2011 年 10 月 15 日",
}